/**
 * CustomerLabs custom-event helper for WL/ED assessment + PLP cart.
 * POSTs JSON to the Shopify Custom Event webhook; identifies via _cl when present.
 */
(function (global) {
  'use strict';

  var DEFAULT_WEBHOOK =
    'https://hook.customerlabs.co/source/shopify-custom-event-b4cjr2qu85kt/';
  var ONCE_PREFIX = 'wm_cl_once_';

  function config() {
    return global.__wmClEventsConfig || {};
  }

  function webhookUrl() {
    return (config().webhookUrl || DEFAULT_WEBHOOK).trim();
  }

  function clUid() {
    try {
      return (
        (global.CLabsgbVar &&
          global.CLabsgbVar.generalProps &&
          global.CLabsgbVar.generalProps.uid) ||
        ''
      );
    } catch (e) {
      return '';
    }
  }

  function onceKey(eventName, email) {
    var e = String(email || '')
      .trim()
      .toLowerCase();
    return ONCE_PREFIX + String(eventName || '') + (e ? '__' + e : '');
  }

  function alreadySent(eventName, email) {
    try {
      return !!sessionStorage.getItem(onceKey(eventName, email));
    } catch (e) {
      return false;
    }
  }

  function markSent(eventName, email) {
    try {
      sessionStorage.setItem(onceKey(eventName, email), '1');
    } catch (e) {}
  }

  function clProp(type, value) {
    return { t: type, v: value };
  }

function identify(props) {
  var p = props || {};
  if (!global._cl || typeof global._cl.identify !== 'function') return;
  var email = (p.email || '').trim();
  var phone = (p.phone || '').trim();
  if (!email && !phone) return;

  var traits = {};
  if (p.first_name) traits.first_name = clProp('string', p.first_name);
  if (p.last_name) traits.last_name = clProp('string', p.last_name);
  if (email) traits.email = clProp('string', email);
  if (phone) traits.phone = clProp('string', phone);

  var customProperties = {
    user_traits: {
      t: 'Object',
      v: traits
    }
  };

  if (email) {
    customProperties.identify_by_email = {
      t: 'string',
      v: email,
      ib: true
    };
    /* Phone as secondary external ID (shows in Helper EXTERNAL IDS) */
    if (phone) {
      customProperties.external_ids = {
        t: 'Object',
        v: {
          identify_by_phone: {
            t: 'string',
            v: phone
          }
        }
      };
    }
  } else if (phone) {
    customProperties.identify_by_phone = {
      t: 'string',
      v: phone,
      ib: true
    };
  }

  var properties = { customProperties: customProperties };
  try {
    console.info('[WmClEvents] identify', properties);
    global._cl.identify(properties);
  } catch (e) {
    try {
      console.warn('[WmClEvents] identify failed', e);
    } catch (e2) {}
  }
}

  function buildPayload(eventName, props) {
    var p = props || {};
    var body = {
      event_name: eventName,
      email: p.email || '',
      phone: p.phone || '',
      first_name: p.first_name || '',
      last_name: p.last_name || '',
      customerlabs_user_id: clUid(),
      funnel: p.funnel || '',
      page_url: global.location ? String(global.location.href) : '',
      timestamp: new Date().toISOString()
    };
    /* Nested products[] only (no flat product_* duplicates on root) */
    if (p.product_id || p.variant_id || p.product_title) {
      body.products = [
        {
          product_id: p.product_id || '',
          variant_id: p.variant_id || '',
          title: p.product_title || '',
          handle: p.product_handle || '',
          sku: p.sku || '',
          price: p.price != null ? p.price : '',
          quantity: p.quantity != null ? p.quantity : 1
        }
      ];
    }
    return body;
  }

  function postWebhook(body) {
    var url = webhookUrl();
    if (!url) {
      try {
        console.warn('[WmClEvents] no webhook URL configured');
      } catch (e0) {}
      return;
    }
    var json = JSON.stringify(body);

    /*
     * Send exactly once. Do not retry on fetch failure — with CORS, CL often
     * receives the first POST then the browser rejects reading the response,
     * and a fallback would create duplicate log entries.
     * text/plain avoids a CORS preflight (simple request).
     */
    try {
      if (global.navigator && typeof global.navigator.sendBeacon === 'function') {
        var queued = global.navigator.sendBeacon(
          url,
          new Blob([json], { type: 'text/plain;charset=UTF-8' })
        );
        try {
          console.info(
            '[WmClEvents] webhook queued via sendBeacon',
            body.event_name,
            queued ? 'ok' : 'failed'
          );
        } catch (eLog) {}
        if (queued) return;
      }
    } catch (eBeacon) {}

    try {
      global
        .fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: json,
          keepalive: true,
          mode: 'no-cors',
          credentials: 'omit'
        })
        .then(function () {
          try {
            console.info(
              '[WmClEvents] webhook sent via fetch(no-cors)',
              body.event_name
            );
          } catch (eLog2) {}
        })
        .catch(function (err) {
          try {
            console.warn('[WmClEvents] webhook send failed (not retrying)', err);
          } catch (eLog3) {}
        });
    } catch (eFetch) {
      try {
        console.warn('[WmClEvents] webhook post error', eFetch);
      } catch (eLog4) {}
    }
  }

  /**
   * @param {string} eventName
   * @param {object} [props]
   * @param {{ once?: boolean }} [opts] — once:true = fire at most once per session
   */
  function track(eventName, props, opts) {
    if (!eventName) return;
    var options = opts || {};
    var payload = buildPayload(eventName, props);
    var url = webhookUrl();
    var json = JSON.stringify(payload, null, 2);
    var email = (props && props.email) || payload.email || '';
    var skipped = !!(options.once && alreadySent(eventName, email));

    try {
      console.group(
        '[WmClEvents] ' + (skipped ? 'SKIP (already sent) → ' : 'sending → ') + eventName
      );
      console.info('webhook:', url);
      console.info('payload object:', payload);
      console.info('payload JSON:', json);
      if (skipped) {
        console.warn(
          'Already sent for this email this session. Clear with:',
          "sessionStorage.removeItem('" + onceKey(eventName, email) + "')"
        );
      }
      console.groupEnd();
    } catch (e1) {
      try {
        console.info('[WmClEvents]', skipped ? 'skip' : 'sending', eventName, url, payload);
      } catch (e2) {}
    }

    if (skipped) return;

    identify(props);
    postWebhook(payload);
    if (options.once) markSent(eventName, email);
  }

  function identityFromAnswers(answers) {
    var a = answers || {};
    return {
      email: a.email || '',
      phone: a.phone || '',
      first_name: a.first_name || '',
      last_name: a.last_name || ''
    };
  }

  global.WmClEvents = {
    track: track,
    identityFromAnswers: identityFromAnswers,
    DEFAULT_WEBHOOK: DEFAULT_WEBHOOK
  };
})(typeof window !== 'undefined' ? window : this);